if (!customElements.get('workshop-continue-browsing')) {
  customElements.define('workshop-continue-browsing', class extends HTMLElement {
    constructor() {
      super();
      this.onLinkClick = this.onLinkClick.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.onLinkClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onLinkClick);
    }

    onLinkClick(event) {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
      if (!link || !this.contains(link) || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;

      const destination = new URL(link.href, document.baseURI);
      if (destination.origin !== window.location.origin || destination.pathname !== window.location.pathname) return;

      const drawer = this.closest('cart-drawer');
      if (!drawer || typeof drawer.hide !== 'function') return;

      event.preventDefault();
      drawer.hide();
    }
  });
}

if (!customElements.get('workshop-card-purchase')) {
  customElements.define('workshop-card-purchase', class extends HTMLElement {
    constructor() {
      super();
      this.onFormSubmit = this.onFormSubmit.bind(this);
      this.onProductAdded = this.onProductAdded.bind(this);
      this.onBusyChange = this.onBusyChange.bind(this);
    }

    connectedCallback() {
      this.form = this.querySelector('form[is="product-form"]');
      this.submitButton = this.form?.querySelector('[type="submit"]');
      this.cartStatus = this.querySelector('[data-workshop-cart-status]');
      if (!this.form || !this.submitButton || !this.cartStatus) return;

      this.addEventListener('submit', this.onFormSubmit, true);
      document.addEventListener('ajaxProduct:added', this.onProductAdded);
      this.busyObserver = new MutationObserver(this.onBusyChange);
      this.busyObserver.observe(this.submitButton, { attributes: true, attributeFilter: ['aria-busy'], attributeOldValue: true });
    }

    disconnectedCallback() {
      this.removeEventListener('submit', this.onFormSubmit, true);
      document.removeEventListener('ajaxProduct:added', this.onProductAdded);
      this.busyObserver?.disconnect();
      this.busyObserver = null;
      this.pendingSubmission = null;
    }

    onFormSubmit(event) {
      if (event.target !== this.form || this.submitButton.disabled || this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.cartStatus.hidden = true;
      this.cartStatus.textContent = '';
      this.pendingSubmission = {
        variantId: this.form.querySelector('[name="id"]')?.value,
        sawBusy: false,
        confirmed: false
      };
    }

    onProductAdded(event) {
      if (!this.pendingSubmission) return;
      if (this.submitButton.getAttribute('aria-busy') === 'true') {
        this.pendingSubmission.sawBusy = true;
      }
      if (!this.pendingSubmission.sawBusy) return;

      const addedVariantId = event.detail?.product?.id;
      if (addedVariantId != null && String(addedVariantId) === String(this.pendingSubmission.variantId)) {
        this.pendingSubmission.confirmed = true;
      }
    }

    onBusyChange(records) {
      const submission = this.pendingSubmission;
      if (!submission) return;

      const isBusy = this.submitButton.getAttribute('aria-busy') === 'true';
      if (isBusy || records.some(record => record.target === this.submitButton && record.oldValue === 'true')) {
        submission.sawBusy = true;
      }
      if (isBusy || !submission.sawBusy) return;

      queueMicrotask(() => {
        if (!this.isConnected || this.pendingSubmission !== submission || this.submitButton.getAttribute('aria-busy') === 'true') return;

        this.pendingSubmission = null;
        if (submission.confirmed || this.hasVisibleNativeError()) return;

        const message = this.getAttribute('data-cart-uncertain-message');
        if (!message) return;
        this.cartStatus.textContent = message;
        this.cartStatus.hidden = false;
      });
    }

    hasVisibleNativeError() {
      const error = this.form.querySelector('.product-form__error-message');
      if (!error || error.hidden || error.closest('[hidden], [aria-hidden="true"]') || !error.textContent.trim()) return false;

      const style = window.getComputedStyle(error);
      return style.display !== 'none' && style.visibility !== 'hidden';
    }
  });
}
